import LazyLoad from "react-lazyload";

import dynamic from "next/dynamic";

import ButtonNew from "components/atoms/ButtonNew/index";
import { BsCheck } from "components/atoms/Icon/bs/BsCheck";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import BankingOptions from "components/organisms/BankingOptions";
import Banner from "components/organisms/Banner/index.js";
import Faqs from "components/organisms/Faqs";
import HowItWorks from "components/organisms/HowItWorks";
import RequiredDocuments from "components/organisms/RequiredDocument";
import WhyChooseUs from "components/organisms/WhyChooseUs";

import { noteTraditional } from "../../../organisms/BankingOptions/bankNote";

import styles from "./Index.module.scss";
const NewsSlider = dynamic(() => import("components/organisms/NewsSlider"), {
  ssr: false,
});

const BankingSupport = ({ dataJson, data, dataBank }) => {
  return (
    <>
      <Banner
        minHeightBanner="banner-min-h-569"
        breadcrumbs={dataJson?.breadcrumbs}
        title="Opening A Corporate <br/>Bank account"
        leftContent={
          <div className="mb-6 text-center lg:col-11 lg:mb-14 lg:text-left">
            Worldwide banking with professional support and careful process in
            step-by-step
          </div>
        }
        titleProps={{
          className: "banner-default-title mb-6 capitalize",
          textColor: "bg-bbc-gradient-liner1 text-transparent bg-clip-text",
        }}
        leftClassName="lg:col-7 lg:pr-[65px] lg:mb-10"
        rightClassName="lg:col-5"
        rightContent={
          <Img
            src="/assets/images/offshore/banking-support/banner-offshore-banking.png"
            wrapper={{
              className: "bbc-banner-image-country pb-20 lg:pb-10 ",
            }}
            className="h-full w-full"
            width={622}
            height={400}
            alt="offshore bank account opening support service"
          />
        }
        bgColor="bg-bbc-gradient-service"
      ></Banner>
      <section className={`relative z-10 ${styles.bankingTool}`}>
        <div className="lg:container">
          <div className="m-auto lg:col-10 ">
            <div className="flex flex-col-reverse items-center rounded-3xl bg-bbc-gradient-liner1 px-6 pb-6 pt-10 lg:flex-row ">
              <div className="text-center lg:col-5">
                <p className="mb-6 text-left text-3xl font-semibold text-bbc-main">
                  BBCIncorp’s Online
                  <br /> Banking Tool
                </p>
                <p className="mb-6 text-left text-bbc-white">
                  Simplify your banking choice with easy steps
                </p>
                <div className="text-center lg:text-left">
                  <ButtonNew
                    as="a"
                    href="/guide-and-tool/banking-tool"
                    variant={"outline"}
                    useRouter
                    btnBorder="border border-white"
                    btnColor={"bg-transparent hover:bg-white"}
                    btnTextColor={"text-white hover:text-bbc-brand-500"}
                  >
                    Try Now
                  </ButtonNew>
                </div>
              </div>
              <div className="lg:col-7">
                <Img
                  src="/assets/images/offshore/banking-support/services1-offshore-banking.png"
                  className=""
                  alt="Banking Tool"
                  width={544}
                  height={432}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <Title className="title-h2 mb-4 text-center text-bbc-brand-800  lg:mb-6 ">
            Cannot do business without banking?
          </Title>
          {dataJson?.dataBanking?.description.map((item, index) => (
            <p className="mb-6 last:mb-10" key={index}>
              {item}
            </p>
          ))}
          <div className="row items-center">
            <div className="lg:col-6">
              <h3 className="mb-4 text-2xl font-semibold text-bbc-brand-800 ">
                Offshore banking benefits
              </h3>
              <ul>
                {dataJson?.dataBanking?.lists.map((item, index) => (
                  <li className="mb-3 flex" key={index}>
                    <span className="pt-[4px]">
                      <BsCheck className=" mr-2 text-bbc-brand-400" />
                    </span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="order-first mb-6 lg:col-6 lg:order-last lg:mb-0">
              <Img
                src="/assets/images/offshore/banking-support/benefits-offshore-banking.png"
                className="h-full w-full"
                width={537}
                height={340}
                alt="benefits of offshore business bank account"
              />
            </div>
          </div>
        </div>
      </section>
      <WhyChooseUs
        title="Why choose us for banking introduction"
        sectionClassName="bg-bbc-gradient-3 py-10 lg:py-20 capitalize"
        data={dataJson?.dataWhyChooseUs}
      />
      <section>
        <HowItWorks data={dataJson?.dataMakeItWork}>
          <Title className="text-center font-semibold capitalize lg:text-left">
            <span className="block text-3xl text-bbc-brand-800 lg:text-bbc-40px">
              How
            </span>
            <span className="mt-4 block text-3xl text-bbc-brand-700 lg:text-4xl lg:leading-[44px]">
              It Works
            </span>
          </Title>
        </HowItWorks>
      </section>
      <section>
        <div className="container">
          <BankingOptions
            title={"Countries for Overseas Banking"}
            description="It does not mean that a BVI company must choose a bank account in BVI. Many owners of offshore companies tend to incorporate their companies in one country and open the offshore accounts independently, in a location that is known as a “financial centre”. Examples of widely known financial centres are Hong Kong Singapore, Switzerland, Austria or Luxembourg. We offer bank account introductions in several major jurisdictions, and in many cases, depending on client's business profile and needs, one bank might be preferred over others."
            dataTraditional={dataBank?.traditional}
            dataEMI={dataBank?.emi}
            noteTraditional={noteTraditional(dataBank.traditional, true)}
          />
        </div>
      </section>
      <section>
        <RequiredDocuments
          sectionClassName=" pt-14 pb-20"
          backgroundImage="/assets/images/common/required-documents.png"
          title="Document requirements"
          data={dataJson?.dataRequiredDocuments}
        />
      </section>
      <section>
        <div className="container">
          <div className="lg:col-10 lg:mx-auto">
            <Faqs
              data={dataJson.dataFaqs}
              // Description =""
            />
          </div>
        </div>
      </section>
      <section className="mb-0">
        <div className="container">
          <Title className="title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800">
            Industry News & Insights
          </Title>
          <LazyLoad>
            <NewsSlider data={data} />
          </LazyLoad>
        </div>
      </section>
    </>
  );
};

export default BankingSupport;
